export default __webpack_public_path__ + "static/media/helpful-resources-tablet.89bea643.webp";